import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Url } from '@wix/da-url';
import { PapiUser } from '@wix/da-papi-types';
import { requestJoinGroup } from '@wix/da-shared-react/pkg/redux/groups/actions';
import { AppState } from '../../../../types/store';
import {
  isCurrentUserProfileOwner,
  getProfileOwnerUser,
  getProfileOwnerStat,
  getProfileOwnerExtendedGroup,
} from '../../../selectors/users';

import { getModuleData } from '../../../selectors/modules';
import { Props as WidgetBoxProps } from '../../UserWidgets/_partials/WidgetBox';
import { Props as GroupAboutProps } from './GroupAbout';

type Props = GroupAboutProps & WidgetBoxProps;
type StateProps = Pick<
  Props,
  | 'profileOwnerUser'
  | 'isOwner'
  | 'watchers'
  | 'pageviews'
  | 'members'
  | 'isMember'
  | 'isAdmin'
>;
type DispatchProps = Pick<
  Props,
  'messageAdmins' | 'inviteToGroup' | 'requestToJoin'
>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => {
  const moduleData = getModuleData(state, ownProps.moduleId);
  const extendedGroup = getProfileOwnerExtendedGroup(state) || {};
  const { membersCount, isMember, isAdmin } = extendedGroup;
  return {
    ...moduleData,
    profileOwnerUser: getProfileOwnerUser(state),
    watchers: getProfileOwnerStat(state, 'watchers'),
    pageviews: getProfileOwnerStat(state, 'pageviews'),
    members: membersCount || 0,
    isMember: isMember || false,
    isAdmin: isAdmin || false,

    isOwner: isCurrentUserProfileOwner(state),
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch,
  ownProps
) => ({
  messageAdmins: (profileOwnerUser: PapiUser) =>
    window.location.assign(Url.userNoteLink(profileOwnerUser.username)),
  requestToJoin: (profileOwnerUser: PapiUser) =>
    dispatch(requestJoinGroup(profileOwnerUser)),
  inviteToGroup: (profileOwnerUser: PapiUser) => {},
});

export default connect(mapStateToProps, mapDispatchToProps);
